import { render, staticRenderFns } from "./Tab1UserIdentity.vue?vue&type=template&id=2d586707"
import script from "./Tab1UserIdentity.vue?vue&type=script&lang=ts"
export * from "./Tab1UserIdentity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports